import { Footer, Header } from 'antd/es/layout/layout';
import {
  Button,
  Col,
  FloatButton,
  Image,
  Row,
  Select,
  notification,
  theme,
} from 'antd';
import imageHeader from '../../Assets/headColor.png';
import { Link, useNavigate } from 'react-router-dom';

import { useEffect, useState } from 'react';
import { CloseCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';

import style from './FooterBar.module.css';
import { useTranslation } from 'react-i18next';
import { LocalHelper } from '../../Helpers/LocalHelper';
import { Language } from '../../Models/Language/Language';
import { serviceBundler } from '../../App';
import AvatarDropdown from '../AvatarDropDown/AvatarDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { ShowTour } from '../Devices/Forms/Tour/ShowTour';

const { useToken } = theme;

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const FooterBar = () => {
  let navigate = useNavigate();

  const { i18n, t } = useTranslation();
  const { token } = useToken();
  const [api, contextHolder] = notification.useNotification();

  const NavigateToContact = () => {
    navigate('/overandcontact');
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  const [tourModelOpen, setTourModelOpen] = useState<boolean>(false);

  useEffect(() => {}, [0]);

  return (
    <Footer
      style={{ backgroundColor: token?.colorPrimaryBg }}
      className={style.headerBlock}
    >
      <ShowTour
        open={tourModelOpen}
        onCancel={() => setTourModelOpen(false)}
      ></ShowTour>
      <FloatButton
        onClick={() => setTourModelOpen(true)}
        shape="square"
        tooltip={t('questions') + '?'}
        icon={<QuestionCircleOutlined />}
        type="default"
        style={{ bottom: 40, right: 30 }}
      />
    </Footer>
  );
};

export default FooterBar;
